import { useReducer } from 'react'

import type { ViewAction } from 'tripPlanner/contexts/View/ViewState'
import type ViewState from 'tripPlanner/contexts/View/ViewState'
import {
  viewStateReducer,
  VIEW_INITIAL_STATE,
} from 'tripPlanner/contexts/View/ViewState'

export default function useViewState(
  initialState: ViewState = VIEW_INITIAL_STATE,
) {
  const [state, dispatch] = useReducer<ViewState, [ViewAction]>(viewStateReducer, initialState)
  return { state, dispatch }
}
